import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PatientStatusComponent } from './patient-status.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [PatientStatusComponent],
  exports: [PatientStatusComponent]
})
export class PatientStatusModule { }
